// test1761
(1761 && 0);
